import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { authService } from '@/services/auth.service';
import { useAuthStore } from '@/stores/auth.store';

/**
 * Cierre de sesión completo, compartido por el menú lateral (DashboardLayout) y por la
 * guarda de RoleRoute: cierra la sesión en el servidor (revoca los refresh tokens), limpia
 * el cache de React Query (para que el próximo login no muestre el perfil del usuario anterior),
 * limpia el store y vuelve al login. Si el servidor falla, igual se cierra localmente.
 * Devuelve true si el servidor confirmó el cierre.
 */
export function useLogout() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const logout = useAuthStore((state) => state.logout);

    return useCallback(async (): Promise<boolean> => {
        let cerradaEnServidor = true;
        try {
            await authService.logout();
        } catch {
            cerradaEnServidor = false;
        }
        queryClient.clear();
        logout();
        navigate('/login', { replace: true });
        return cerradaEnServidor;
    }, [navigate, queryClient, logout]);
}
